import { createContext as F, useState as h, useEffect as y, useContext as C } from "react";
import { h as x, i as I, g, a as z } from "./domains-bf220bf9.js";
import { j as l } from "./jsx-runtime-944c88e2.js";
import { useQuery as D } from "@tanstack/react-query";
import { k as E } from "./useAccount-2421e215.js";
import "./myasurion-shared.mixpanel.es.js";
const p = F({
  features: null,
  isInitialized: !1
}), j = ({
  config: e,
  children: n
}) => {
  const [r, t] = h(!1), a = x() ? I() : g(), { data: o, refetch: u } = D({
    retry: (s, i) => {
      var d, m;
      return console.error("Error fetching firebase feature config", i), !(((d = i == null ? void 0 : i.response) == null ? void 0 : d.status) === 403 || ((m = i == null ? void 0 : i.response) == null ? void 0 : m.status) === 401 || s === 5);
    },
    retryDelay: (s) => Math.min(1e3 * 2 ** s, 3e4),
    queryKey: ["featureConfigData", e],
    queryFn: () => {
      var s;
      return E(
        e,
        `feature_flag_${a}_${(s = e == null ? void 0 : e.env) == null ? void 0 : s.toLowerCase()}`
      ).then((i) => JSON.parse(i ?? "{ partnerId: 'asurion' }")).catch(() => null).finally(() => t(!0));
    },
    enabled: !1
  });
  return y(() => {
    e && u();
  }, [e]), /* @__PURE__ */ l.jsx(
    p.Provider,
    {
      value: { features: o, isInitialized: r },
      children: r ? n : /* @__PURE__ */ l.jsx(l.Fragment, {})
    }
  );
};
function f(e, n) {
  if (e)
    for (const r of e) {
      const t = v(r, n);
      if (t)
        return t;
    }
}
function v(e, n) {
  if (e.key === n)
    return e;
  if (e.options)
    for (const r of e.options) {
      const t = v(r, n);
      if (t && "isEnabled" in t)
        return t.isEnabled === !0 ? t : void 0;
    }
}
const k = (e) => {
  var u, s;
  const n = C(p);
  if (n === void 0)
    throw new Error("useFeature must be used within a Feature Provider");
  const r = z(), { features: t, isInitialized: c } = n, a = (u = t == null ? void 0 : t.featureList) == null ? void 0 : u[r ?? "device_protection"], o = a == null ? void 0 : a.find((i) => (i == null ? void 0 : i.key) === e);
  return {
    remoteConfig: t,
    isOn: !!o,
    version: o == null ? void 0 : o.version,
    isFeatureOn: !!f(a, e),
    feature: f(a, e),
    featureVersion: (s = f(a, e)) == null ? void 0 : s.version,
    findValue: f,
    isFeatureInitialized: c
  };
};
export {
  j as F,
  p as a,
  k as u
};
